import {type FunctionalComponent, h,type JSX, type VNode} from '@stencil/core';
import type {GuidedV2LinkAttribute, GuidedV2LinkTag} from '../../models/quick-link';
import type {GuidedV2Emitters} from '../../models/eventNames';
import {GuidedV2LinkAttributeRender} from '../link-attribute-render/link-attribute-render';
import {GuidedV2LinkTagRender} from '../link-tag-render/link-tag-renderer';



type FallbackRenderLinkProps = {
  title: string | JSX.Element,
  description?: string | JSX.Element,
  url: string,
  tags: {
    attributes: Array<GuidedV2LinkAttribute>,
    tags: Array<GuidedV2LinkTag>
  },
  eventEmitters: GuidedV2Emitters,
  category?: string
};
// Specific templated related to quick-links are to be defined within `result-items` directory.


export const GuidedV2FallbackQuickRenderLink: FunctionalComponent<FallbackRenderLinkProps> = (props)=>{

    const {title, description, url, tags, eventEmitters, category} = props;

    const emitters = eventEmitters() ?? undefined;

    if(emitters == undefined){
      console.error("No event emitters found"); //eslint-disable-line
    }
    const clickEmitter = (ev:MouseEvent) => {
        const clickEvent = emitters.completed.emit({
          link: url,
          event: 'guidedSearchClick',
          category: category
        });

        if (clickEvent.defaultPrevented) {
          ev.preventDefault();
        }
    };

    return <li class="guided-v2-result-list-section__result add-selector-strength">
      <a class="guided-v2-result-list-section__result-link add-selector-strength" href={url} onClick={clickEmitter}>

        <div class="guided-v2-result-list-section__result-title add-selector-strength" >
          {title}
          {description && <span>- {description}</span>}
        </div>

        <div class="guided-v2-result-list-section__result-extra add-selector-strength">

          {tags.attributes.map(attribute=><GuidedV2LinkAttributeRender
            attribute={attribute}
          ></GuidedV2LinkAttributeRender>)}

          {tags.tags.map(tag=><GuidedV2LinkTagRender
            tag={tag}
          ></GuidedV2LinkTagRender>)}

        </div>
      </a>
    </li> as VNode;
};
